<template>
  <!-- 主页 -->
  <div class="home">
    <!-- bannar+主体 -->
    <img
      :src="bannarList[0].imgs"
      class="bannar"
      v-if="bannarList.length == 1"
    />

    <swiper
      ref="mySwiper0"
      :options="swiperOptionBannar"
      v-if="bannarList.length > 1"
      class="bannarList"
    >
      <swiper-slide v-for="(item, index) in bannarList" :key="index">
        <img :src="item.imgs" class="bannar" />
      </swiper-slide>
      <div class="swiper-button-prev"></div>
      <!--左箭头。如果放置在swiper-container外面，需要自定义样式。-->
      <div class="swiper-button-next"></div>
      <!--右箭头。如果放置在swiper-container外面，需要自定义样式。-->
    </swiper>

    <!-- 1.简介 -->
    <div class="model model1">
      <Minetitle :title1="titleArr[0].title1" :title2="titleArr[0].title2" />
      <div class="model1_main clearfix">
        <!-- 视频 -->
        <div v-show="windowWidth > 1400">
          <div class="videoModel" @click="openVideo">
            <video
              style="object-fit: fill"
              src=""
              class="model1_video"
              :poster="videoPoster"
            ></video>
            <img
              src="../../public/img/home/play.png"
              alt=""
              class="btn_playVideo"
            />
          </div>
          <!-- 关于我们 -->
          <div class="model1_floor1">
            <div class="model1_floor1_title">关于我们<b>/ABOUT</b></div>
            <el-input
              type="textarea"
              class="model1_context"
              disabled
              rows="15"
              resize="none"
              v-model="company.context"
            ></el-input>
          </div>
        </div>
        <div v-show="windowWidth < 1400">
          <div class="videoModel videoModel2" @click="openVideo">
            <video
              style="object-fit: fill"
              src=""
              class="model1_video"
              :poster="videoPoster"
            ></video>
            <img
              src="../../public/img/home/play.png"
              alt=""
              class="btn_playVideo"
            />
          </div>
          <!-- 关于我们 -->
          <div class="model1_floor1 model1_floor1_s">
            <div class="model1_floor1_title">关于我们<b>/ABOUT</b></div>
            <el-input
              type="textarea"
              class="model1_context model1_context_s"
              disabled
              rows="11"
              resize="none"
              v-model="company.context"
            ></el-input>
          </div>
        </div>

        <div class="model1_floor2">
          <div v-if="company.imgs.length < 3">
            <img
              class="model1_pic"
              v-for="(item, index) in company.imgs"
              :src="item"
              alt=""
              :key="index"
            />
          </div>
          <swiper
            ref="mySwiper"
            :options="swiperOptions0"
            v-if="company.imgs.length >= 3"
          >
            <swiper-slide v-for="(item, index) in company.imgs" :key="index">
              <img class="model1_pic" :src="item" alt="" />
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
    <!-- 2.企业实力数据 -->
    <div class="model model2">
      <Minetitle :title1="titleArr[1].title1" :title2="titleArr[1].title2" />
      <swiper
        class="swiperStrength"
        v-if="strengthList.length > 0"
        :options="strengthOption"
      >
        <swiper-slide
          class="swiper-slide"
          v-for="item in strengthList"
          :key="item"
        >
          <div class="model2_icon">
            <img :src="item.imgs" style="width: 100px; height: 100px" alt="" />
          </div>
          <div class="model2_num">
            <CountTo
              :start-val="0"
              :end-val="item.link"
              :duration="1000"
              :autoplay="true"
              v-if="numStatus[0]"
            ></CountTo
            ><span class="tip" style="font-size: 44px; color: #333">+</span>
          </div>
          <p class="model2_line"></p>
          <p class="model2_des">{{ item.context }}</p>
        </swiper-slide>
      </swiper>
      <div v-else class="tips">暂无数据，敬请期待！</div>
    </div>
    <!-- 3.解决方案 -->
    <div class="model model3">
      <div class="model3_shadow"></div>
      <Minetitle :title1="titleArr[2].title1" :title2="titleArr[2].title2" />
      <div class="btn_lookMore" @click="more_solution">查看更多></div>
      <!-- 具体 -->
      <ul class="model3_ul">
        <li class="model3_li" v-for="item in solutionList" :key="item.id">
          <img :src="picUrl + item.picUrl" alt="" class="model_pic" />
          <div class="model3_li_mb">
            <img :src="picUrl + item.iconUrl" alt="" class="model3_icon" />
            <p class="model3_des">{{ item.des }}</p>
            <ul class="model3_arr">
              <li
                class="model3_arrli"
                v-for="item2 in item.arr"
                :key="item2.id"
              >
                {{ item2.name }}
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
    <!-- 4.核心产品 -->
    <div class="model model4" id="homeSwiper">
      <Minetitle :title1="titleArr[3].title1" :title2="titleArr[3].title2" />
      <!-- <div class="btn_lookMore" @click="more_product">查看更多></div> -->
      <div class="swiper">
        <!-- limian -->
        <el-carousel :interval="3000" arrow="always" height="4rem">
          <el-carousel-item
            v-for="item in productList"
            :key="item.id"
            class="product_item"
          >
            <div @click="gotoDetail(item)" class="product_li">
              <img :src="item.imgs" alt="" class="product_pic" />
              <el-button type="primary" class="product_name">{{
                item.title
              }}</el-button>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <!-- 5.重要里程 -->
    <div class="model model5">
      <div class="model3_shadow"></div>
      <Minetitle :title1="titleArr[4].title1" :title2="titleArr[4].title2" />
      <!-- 里程 -->
      <div class="model5_center">
        <img class="btn_prev" src="../../public/img/home/arrow.png" alt="" />
        <img class="btn_next" src="../../public/img/home/arrow.png" alt="" />
        <div class="model5_line"></div>
        <div class="swiper">
          <swiper ref="mySwiper" :options="swiperOptions">
            <swiper-slide v-for="(item, index) in lcList" :key="index">
              <li class="list_li">
                <div class="point1">
                  <div class="point2"></div>
                </div>
                <div class="list_line"></div>
                <p class="list_time">
                  {{ item.year }}-{{
                    item.month > 10 ? item.month : "0" + item.month
                  }}
                </p>
                <div class="list_des">
                  <div
                    v-for="(item2, index) in item.monthBigEvents.slice(0, 2)"
                    :key="index"
                    style="margin-bottom: 16px"
                  >
                    <b>·</b>
                    <span>{{ item2.context }}</span>
                  </div>
                </div>
              </li>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
    <!-- 6.新闻资讯 -->
    <div class="model model6">
      <Minetitle :title1="titleArr[5].title1" :title2="titleArr[5].title2" />
      <div class="btn_lookMore" @click="more_news">查看更多></div>
      <!-- 3资讯展示 -->
      <ul class="model6ul">
        <li
          class="model6li"
          v-for="item in arrNews"
          :key="item.id"
          @click="gotoNews(item)"
        >
          <img class="model6pic" :src="item.coverImg" alt="" />
          <p class="model6title">{{ item.title }}</p>
          <p class="model6time">{{ item.updateTime }}</p>
          <div class="btn_lookDetail">查看详情></div>
        </li>
      </ul>
    </div>
    <!-- 视频 -->
    <el-dialog
      title="视频"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="closeVideo"
    >
      <video :src="videoUrl" class="mineVideo" controls id="video"></video>
    </el-dialog>
  </div>
</template>

<script>
var _hmt = _hmt || [];
(function () {
  var hm = document.createElement("script");
  hm.src = "http://hm.baidu.com/hm.js?c41b87bf44cdd029dae73e3e312d2048";
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(hm, s);
})();
import Minetitle from "../components/minetitle.vue";
import { swiper, swiperSlide, Swiper, SwiperSlide } from "vue-awesome-swiper";
import { getFunc } from "@/api/home";
import { picUrl } from "@/config/env";
import CountTo from "vue-count-to"; //数字滚动
import { postPv } from "@/api/postPv";

// @ is an alias to /src
export default {
  name: "Home",
  data() {
    return {
      numStatus: [false, false, false, false], //20 300 200 20
      windowWidth: "", //用于适配屏幕尺寸
      picUrl: "", //用于图片拼接
      swiperOptionBannar: {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        observerParent: true,
        observer: true,
        autoplay: {
          delay: 2000, //自动切换的时间间隔，单位ms自动切换会在slide过渡完毕后才开始计时。
        },
        effect: "fade",
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      swiperOptions0: {
        slidesPerView: 3,
        spaceBetween: 21,
        loop: true,
        observerParent: true,
        observer: true,
        autoplay: {
          delay: 2000, //自动切换的时间间隔，单位ms自动切换会在slide过渡完毕后才开始计时。
        },
      },
      swiperOptions: {
        slidesPerView: 3,
        spaceBetween: 0,
        navigation: {
          nextEl: ".btn_next", //前进
          prevEl: ".btn_prev", //后退
        },
        loop: false,
        observerParent: true,
        observer: true,
        // autoplay: {
        //   delay: 2000, //自动切换的时间间隔，单位ms自动切换会在slide过渡完毕后才开始计时。
        // },
      },
      bannarList: [], //bannar图集
      //题目组
      titleArr: [
        { id: 1, title1: "公司简介", title2: "「我们是谁，我们在做什么」" },
        { id: 2, title1: "企业实力数据", title2: "「我们实力不容小觑」" },
        {
          id: 3,
          title1: "解决方案",
          title2: "「为千万客户提供全球领先的解决方案」",
        },
        {
          id: 4,
          title1: "核心产品",
          title2: "「为企业提供领先、安全、稳定的产品」",
        },
        { id: 5, title1: "重要里程", title2: "「公司的成长史」" },
        { id: 6, title1: "新闻资讯", title2: "「通过媒体，了解我们更多」" },
      ],

      videoPoster: "", //
      videoUrl: "", //
      dialogVisible: false,
      company: {
        video: "", //video
        context: "",
        imgs: [], //图片合集
      },
      //解决方案
      solutionList: [
        {
          id: 1,
          picUrl: "/img/home/bg_sl1.jpg",
          iconUrl: "/img/home/icon2-1.png",
          des: "生活垃圾分类",
          arr: [
            { id: 1, name: "智能" },
            { id: 2, name: "前沿" },
            { id: 3, name: "专业" },
          ],
        },
        {
          id: 2,
          picUrl: "/img/home/bg_sl2.jpg",
          iconUrl: "/img/home/icon2-2.png",
          des: "易腐垃圾处理解决方案",
          arr: [
            { id: 1, name: "智能" },
            { id: 2, name: "简单" },
            { id: 3, name: "高效" },
          ],
        },
        {
          id: 3,
          picUrl: "/img/home/bg_sl3.jpg",
          iconUrl: "/img/home/icon2-3.png",
          des: "资源化利用解决方案",
          arr: [
            { id: 1, name: "省事" },
            { id: 2, name: "省力" },
            { id: 3, name: "数字化" },
          ],
        },
        {
          id: 4,
          picUrl: "/img/home/bg_sl4.jpg",
          iconUrl: "/img/home/icon2-4.png",
          des: "数字赋能解决方案",
          arr: [
            { id: 1, name: "智能" },
            { id: 2, name: "前沿" },
            { id: 3, name: "数字化" },
          ],
        },
      ],
      // 核心产品
      productList: [],
      lcList: [],
      //新闻资讯
      arrNews: [
        // {
        //   id: 1,
        //   pic: "/img/home/poster.png",coverImg
        //   title: "这是一个标题",
        //   time: "2021-01-22",   ---updateTime
        // },
      ],
      strengthList: [], //企业实力
      strengthOption: {
        loop: false,
        slidesPerView: "auto",
        loopedSlides: 3,
      },
    };
  },
  watch: {
    $route(to, from) {
      this.$router.go(0);
    },
  },
  methods: {
    handleScroll() {
      let thiz = this;
      //获取滚动时的高度
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let height =
        document.getElementsByClassName("videoModel")[0].offsetHeight;
      let height1 = document.getElementsByClassName("model1")[0].offsetHeight;
      if (scrollTop > height + height1) {
        // console.log('动画');
        let arr = [true, true, true, true];
        thiz.numStatus = arr;
      }
    },
    gotoDetail(item) {
      //有link需要跳转
      console.log(item);
      if (typeof item.link == "undefined") {
        return;
      }
      if (item.link !== "") {
        let link = item.link;
        let lastIndex = link.lastIndexOf("/");
        let id = link.slice(lastIndex + 1, link.length);
        this.$router.push({ path: "/newsdetail", query: { id: id } });
        this.$forceUpdate();
        window.scroll(0, 0);
      }
    },
    gotoNews(item) {
      this.$router.push({ path: "/newsdetail", query: { id: item.id } });
      this.$forceUpdate();
      window.scroll(0, 0);
    },
    closeVideo() {
      this.dialogVisible = false;
      this.$nextTick(() => {
        let video = document.getElementById("video");
        video.pause();
      });
    },
    openVideo() {
      //打开视频
      this.videoUrl = this.company.videos;
      this.dialogVisible = true;
      this.$nextTick(() => {
        let video = document.getElementById("video");
        video.play();
      });
    },
    more_solution() {
      //查看更多解决方案
      this.$router.push("/solution");
      window.scroll(0, 0);
      this.reload();
    },
    more_news() {
      //查看更多
      this.$router.push("/news");
      window.scroll(0, 0);
      this.reload();
    },
  },
  inject: ["reload"],
  mounted() {
    document
      .getElementsByClassName("header")[0]
      .scrollIntoView({ block: "start", behavior: "smooth" });
    let thiz = this;
    let url1 = "/blade-website/web/index/bigEvent"; //type 1:团队风采;2:资质荣誉;3：公司简介；4:核心成员；5：大事件（首页--重要里程）
    //新闻资讯
    let url2 = "/blade-website/web/menu/article/news/list"; //新闻资讯

    let url3 = "/blade-website/web/menu/bigEvent"; //重要里程 (具体年月日走这个接口)
    thiz.$nextTick(() => {
      this.picUrl = picUrl;
      //公司简介
      getFunc(url1, { type: 7 }).then((res) => {
        if (res.code == 200) {
          thiz.bannarList = res.data;
        }
      });
      getFunc(url1, { type: 8 }).then((res) => {
        if (res.code == 200) {
          thiz.strengthList = res.data;
        }
      });
      //公司简介
      getFunc(url1, { type: 3 }).then((res) => {
        if (res.code == 200) {
          const data1 = res.data[0];
          let imgList = data1.imgs.split(",");
          this.company = data1;
          this.videoPoster = imgList[0];
          this.company.imgs = imgList;
        }
      });
      //产品
      getFunc(url1, { type: 6 }).then((res) => {
        if (res.code == 200) {
          const data1 = res.data;
          this.productList = data1;
        }
      });
      //新闻资讯
      getFunc(url2).then((res) => {
        if (res.code == 200) {
          const data2 = res.data.records; //新闻
          let arr = data2.slice(0, 3);
          arr.map((item) => {
            item.updateTime = item.updateTime.slice(0, 10);
            return item;
          });
          thiz.arrNews = arr;
        }
      });
      //大事件（首页--重要里程）
      getFunc(url3).then((res) => {
        if (res.code == 200) {
          const data3 = res.data;
          let final = [];
          for (var i in data3) {
            let item = data3[i].monthBigEvents; //[]
            for (var j in item) {
              let item2 = item[j].monthBigEvents;
              // console.log(item2);
              for (var k in item2) {
                let context = item2[k].context;
                // console.log(context);
                //每个月最多取两个
                context.length > 30
                  ? (item2[k].context = context.slice(0, 38) + "....")
                  : "";
              }
            }
            final.push(...item);
          }
          // console.log(final);
          //data3数组扁平化
          this.lcList = final;
        }
      });
      window.addEventListener("scroll", this.handleScroll);

      postPv("https://www.azureflying.com/api/blade-website/analytics/access")
        .then((res) => {})
        .catch((err) => {});
      //发送pv
      return;
    });
  },
  components: { Minetitle, swiper, swiperSlide, picUrl, CountTo },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style scoped>
.home {
  width: 100%;
  overflow-x: hidden;
}
.bannarList {
  width: 100%;
  height: 882px;
  margin-bottom: 59px;
}
.bannar {
  width: 100%;
  height: 100%;
}
/* 公司简介 */
.model {
  width: 66%;
  max-width: 1360px;
  margin: 0 auto;
  position: relative;
}
.model1_main {
  width: 100%;
}
.videoModel {
  width: 700px;
  height: 369px;
  float: left;
  margin-bottom: 22px;
  position: relative;
  display: flex;
  justify-items: center;
  align-content: center;
}
.videoModel video {
  width: 100%;
  height: 100%;
}
.videoModel img {
  z-index: 99;
  width: 87px;
  height: 87px;
  position: absolute;
  left: 307px;
  top: 141px;
}

.model1_floor1 {
  width: 530px;
  height: 400px;
  float: right;
  /* overflow: auto; */
}
.model1_floor1_title {
  margin-bottom: 18px;
  color: #333;
  font-size: 30px;
  line-height: 1;
}
.model1_floor1_title b {
  color: #999999;
  font-size: 18px;
  margin-left: 11px;
}
.model1_context {
  width: 100%;
  height: 1000px;
}
.model1_context .el-textarea__inner {
  height: 100% !important;
}

.model1_floor2 {
  width: 100%;
  height: 3.25rem;
  margin-bottom: 70px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.model1_pic {
  width: 412px;
  height: 100%;
}
/*  */
.model2_ul {
  margin-bottom: 99px;
  width: 100%;
  height: 295px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.model2_li {
  width: 224px;
  padding-top: 95px;
  height: 100%;
  text-align: center;
  height: auto;
}
.model2_li:hover .model2_icon {
  animation: AntIcon 1s linear;
}
@keyframes AntIcon {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.3);
  }
  100% {
    transform: scale(1);
  }
}
.model2_li:hover .model2_num {
  animation: AntFont 0.5s ease-in-out;
}
@keyframes AntFont {
  0% {
    transform: translateY(30px);
    opacity: 0;
  }
  80% {
    transform: translateY(0);
    opacity: 1;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

.model2_li:hover .model2_des {
  animation: AntFont 0.5s 0.15s ease-in-out;
}
@keyframes AntFont {
  0% {
    transform: translateY(30px);
    opacity: 0;
  }
  80% {
    transform: translateY(0);
    opacity: 1;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

.model2_icon {
  margin-top: 45px;
}

.model2_ul .model2_li:nth-child(1) .model2_icon {
  background: url("../../public/img/home/iconS1.png") no-repeat;
  background-size: cover;
}
.model2_ul .model2_li:nth-child(2) .model2_icon {
  background: url("../../public/img/home/iconS2.png") no-repeat;
  background-size: cover;
}
.model2_ul .model2_li:nth-child(3) .model2_icon {
  background: url("../../public/img/home/iconS3.png") no-repeat;
  background-size: cover;
}
.model2_ul .model2_li:nth-child(4) .model2_icon {
  background: url("../../public/img/home/iconS4.png") no-repeat;
  background-size: cover;
}

.model2_num {
  font-size: 50px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #333333;
  margin-bottom: 0px;
}
.model2_line {
  width: 16px;
  height: 2px;
  background: #999999;
  border-radius: 16px;
  margin: 0 auto 23px;
}
.model2_des {
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #666666;
  margin-bottom: 100px;
  white-space: nowrap;
}

/* 解决方案 */
.model3 {
  width: 67%;
  height: 995px;
  padding: 66px 0 0 0;
  position: relative;
}
.model3_shadow {
  width: 100vw;
  height: 100%;
  position: absolute;
  top: 0;
  left: -26%;
  z-index: 1;
  background: #f7f7f7;
}
.model3_ul {
  position: relative;
  z-index: 2;
  height: 780px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.model3_li {
  width: 49%;
  height: 370px;
  position: relative;
  border-radius: 10px;
  overflow: hidden;
}
.model_pic {
  width: 100%;
  height: 100%;
}
.model3_li_mb {
  position: absolute;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.1);
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  padding-top: 76px;
  box-sizing: border-box;
  flex-direction: column;
}
.model3_icon {
  width: 77px;
  height: 77px;
  margin-bottom: 34px;
  animation: mymove 5s infinite;
}

.model3_des {
  width: 100%;
  height: auto;
  font-size: 34px;
  font-family: Source Han Sans CN;
  font-weight: 300;
  color: #ffffff;
  margin-bottom: 26px;
  text-align: center;
}

.model3_arr {
  width: 70%;
  height: 34px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.model3_arrli {
  width: 96px;
  height: 34px;
  border: 1px solid #ffffff;
  border-radius: 4px;
  line-height: 34px;
  text-align: center;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 300;
  color: #ffffff;
  position: relative;
}
/* 浮动动效 */
.model3_li:hover .model3_des {
  color: #589ef8;
}
.model3_li:hover .model3_icon {
  animation: iconRate 4s;
}
@keyframes iconRate {
  0% {
    transform: rotateY(0deg);
  }
  50% {
    transform: rotateY(360deg);
  }
  100% {
    transform: rotateY(0deg);
  }
}
.model3_li:hover .model3_arr .model3_arrli:nth-child(1) {
  animation: btnMove 1s;
}
.model3_li:hover .model3_arr .model3_arrli:nth-child(2) {
  animation: btnMove 1s 0.25s;
}
.model3_li:hover .model3_arr .model3_arrli:nth-child(3) {
  animation: btnMove 1s 0.5s;
}

@keyframes btnMove {
  0% {
    bottom: 0;
  }
  20% {
    bottom: 10px;
  }
  40% {
    bottom: 0;
  }
  100% {
    bottom: 0;
  }
}

/* 核心产品 */
.btn_lookMore {
  width: 100px;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #589ef8;
  position: absolute;
  top: 108px;
  right: 0;
  z-index: 3;
}
.btn_lookMore:hover,
.btn_lookDetail:hover {
  cursor: pointer;
}
.model4 {
  padding-top: 60px;
  box-sizing: border-box;
}
.swiper {
  width: 100%;
  height: 100%;
}
.product_item {
  width: 100%;
  height: auto;
}
.product_li {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.product_pic {
  width: 1074px;
  height: 600px;
  margin-bottom: 40px;
}
.product_name {
  font-size: 30px;
  font-family: Source Han Sans CN;
  font-weight: 300;
  color: #ffffff;
}
/* 重要里程 */
.model5 {
  padding-top: 60px;
}

/* 新闻资讯 */
.model6 {
  padding-top: 60px;
}
.model6ul {
  width: 100%;
  height: 502px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 70px;
}
.model6li {
  width: 406px;
  height: 100%;
  background: #ffffff;
  box-shadow: 0px 2px 35px 0px rgba(181, 186, 183, 0.21);
  border-radius: 10px;
  overflow: hidden;
}
.model6li:hover {
  transform: translateY(-17px);
  transition: transform 0.2s linear;
}

.model6pic {
  width: 406px;
  height: 277px;
  border-radius: 10px 10px 0 0;
  margin-bottom: 35px;
}
.model6title {
  width: 100%;
  padding: 0 20px;
  height: 26px;
  font-size: 26px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  line-height: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 23px;
}
.model6time {
  padding-left: 20px;
  margin-bottom: 51px;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #666666;
}
.btn_lookDetail {
  padding-left: 20px;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #666666;
  /* color: #589ef8; */
}
.model6li:hover .btn_lookDetail {
  color: #589ef8;
}

.mineVideo {
  /* width: 100%; */
  height: 500px;
}
.el-dialog {
  background: rgba(0, 0, 0, 0.8) !important;
}
.el-dialog__body {
  display: flex;
  justify-content: center;
}
.model5_center {
  width: 100%;
  height: 524px;
  /* overflow: hidden; */
  position: relative;
  z-index: 3;
}
.btn_prev {
  width: 22px;
  height: 23px;
  position: absolute;
  left: -20px;
  top: 50%;
}

.btn_next {
  width: 22px;
  height: 23px;
  position: absolute;
  right: -20px;
  top: 50%;
  transform: rotate(-180deg);
}
.model5_line {
  width: 100%;
  height: 4px;
  background: #dddddd;
  border-radius: 2px;
  position: absolute;
  left: 0;
  top: 52%;
}
.list_li {
  width: 100%;
  height: 520px;
  position: relative;
}
.point1 {
  width: 18px;
  height: 18px;
  background: rgba(88, 158, 248, 0.48);
  border-radius: 9px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 203px;
  top: 264px;
}
.point2 {
  width: 10px;
  height: 10px;
  background: rgba(88, 158, 248, 0.48);
  border-radius: 5px;
}
.list_line {
  width: 2px;
  height: 60px;
  background: #589ef8;
  border-radius: 1px;
  position: absolute;
  left: 212px;
}

.swiper .swiper-slide:nth-child(odd) .list_line {
  top: 295px;
}
.swiper .swiper-slide:nth-child(even) .list_line {
  top: 195px;
}
.list_time {
  width: 100%;
  height: auto;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #666666;
  position: absolute;
  left: 0;
  text-align: center;
}
.swiper .swiper-slide:nth-child(odd) .list_time {
  top: 235px;
}
.swiper .swiper-slide:nth-child(even) .list_time {
  top: 295px;
}

.list_des {
  width: 100%;
  height: auto;
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333;
  position: absolute;
  left: 0;
  text-align: center;
}

.list_des b {
  color: #999;
  margin-right: 7px;
}
.swiper .swiper-slide:nth-child(odd) .list_des {
  top: 363px;
}
.swiper .swiper-slide:nth-child(even) .list_des {
  bottom: 340px;
}

/* 公司简介的图片*/
.model1_floor2 .model1_pic {
  width: 100%;
  height: 3.25rem;
}

/* 1400时候 */
.videoModel2 {
  width: 100%;
  height: 600px;
}
.videoModel2 .btn_playVideo {
  left: 580px;
  top: 300px;
}
.model1_floor1_s {
  width: 100%;
  height: auto;
}
.model1_floor1_s .model1_context {
  height: 180px;
}

.model4 .el-carousel__arrow {
  transform: scale(1.5);
}
.swiperStrength {
  height: 320px;
  overflow: hidden;
}
.swiperStrength .swiper-slide {
  width: 25%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.tips {
  font-size: 24px;
  line-height: 32px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
  padding: 14px 0;
}
</style>
